const currentPageSelector = (state) => state.currentPage;

// Market Reports selectors
const marketReportsSettingsSelector = (state) => state.marketReports.settings;
const marketReportsFiltersSelector = (state) => state.marketReports.filters;
const marketReportsSelector = (state) => state.marketReports.data;

// Research Library selectors
const reportsSelector = (state) => state.researchLibrary.data;
const tickersSelector = (state) => state.researchLibrary.tickers;
const reportsFiltersSelector = (state) => state.researchLibrary.filters;
const reportsSettingsSelector = (state) => state.researchLibrary.settings;

// Custom Exports selectors
const customExportsSettingsSelector = (state) => state.customExports.settings;
const customExportsFiltersSelector = (state) => state.customExports.filters;
const customExportsReportsSelector = (state) => state.customExports.data;
const selectedCustomExportsSelector = (state) => state.customExports.selectedExports;

// Custom Reports selectors
const customReportsSettingsSelector = (state) => state.customReports.settings;
const customReportsFiltersSelector = (state) => state.customReports.filters;
const customReportsSelector = (state) => state.customReports.data;
const versionsSelector = (state) => state.versionHistory.data;
const versionsSettingsSelector = (state) => state.versionHistory.settings;

// KPI Forecasts selectors
const kpiForecastsSettingsSelector = (state) => state.forecasts.settings;
const kpiForecastsSelector = (state) => state.forecasts.data;
const activeForecastSelector = (state) => state.forecasts.data.active;

const currentForecastSettingsSelector = (state) => state.currentForecast.settings;
const currentForecastFiltersSelector = (state) => state.currentForecast.filters;
const currentForecastSelector = (state) => state.currentForecast.data;

export {
  currentPageSelector,
  // Market Reports selectors
  marketReportsSettingsSelector,
  marketReportsFiltersSelector,
  marketReportsSelector,
  // Research Library selectors
  reportsSelector,
  reportsFiltersSelector,
  reportsSettingsSelector,
  tickersSelector,
  // Custom Exports selectors
  customExportsSettingsSelector,
  customExportsFiltersSelector,
  customExportsReportsSelector,
  selectedCustomExportsSelector,
  // Custom Reports selectors
  customReportsSettingsSelector,
  customReportsFiltersSelector,
  customReportsSelector,
  versionsSelector,
  versionsSettingsSelector,
  // KPI Forecasts
  kpiForecastsSettingsSelector,
  kpiForecastsSelector,
  activeForecastSelector,
  currentForecastSettingsSelector,
  currentForecastFiltersSelector,
  currentForecastSelector,
};
